export enum DtwinLifeCycleState {
  PREPROVISIONED = "preprovisioned",
  REGISTERED = "registered",
  ACTIVATED = "activated",
  DISABLED = "disabled",
}
